export enum EnumErrorCodes {
    GenericError = -999,
    CustomError = -998,
    Exception = -997,
    ValidationError = -996,
    ImpactCategorizationValidateError = -995,
    PeriodLockValidationError = -994
}
